export enum UserAdminRoles {
  ADMIN = 1,
  HEADOFOPERATIONS = 2,
  HEADOFDEV = 3,
  HEADOFCONCIERGE = 4,
  CONCIERGE = 5,
  PARTNER = 6,
  EXTERNALAGENT = 7,
  SUPERADMIN = 8
}
